export enum QualityIssueStatus {
	DRAFT = 'claimstatus.draft',
	PENDING_NOT_PUSH = 'claimstatus.pendingnotpush', // for pending quality issues
	PENDING_PUSH = 'claimstatus.pendingpush',
	PENDING = 'claimstatus.pending', // registered by SAP but not resolved // for error case
	CANCELLED = 'claimstatus.cancelled',
	PAID = 'claimstatus.paid',
	REFUSED = 'claimstatus.refused',
	REGWARNING = 'claimstatus.registeredwarning',
}

export enum QualityIssuePendingPushStatus {
	CREATE = 'claimpendingpushstatus.create',
	UPDATE = 'claimpendingpushstatus.update',
	CANCEL = 'claimpendingpushstatus.cancel',
}

export type QualityIssueType = 'warning' | 'issue';
export type QualityIssueSample = 'cts' | 'agency' | 'other' | 'not';
